import type {
	ClustersRequestFilters,
	ClustersResponse
} from '~/core/entities/api/ApiClusters';
import type { ResultTuple } from '~~/core/helpers/result';

import { Result } from '~~/core/helpers/result';
import { createOriginalErrorObject } from '~~/server/utils/errorHandling';
import qs from 'qs';

export interface NuxtClustersRepository {
	list(
		filters: ClustersRequestFilters,
		signal?: AbortSignal
	): Promise<ResultTuple<ClustersResponse>>;
}

export const nuxtClustersRepository: NuxtClustersRepository = {
	async list(
		filters: ClustersRequestFilters,
		signal?: AbortSignal
	): Promise<ResultTuple<ClustersResponse>> {
		try {
			const filtersQuery = qs.stringify(filters, {
				arrayFormat: 'repeat'
			});

			const response = await $fetch<ClustersResponse>(
				`/api/properties/clusters?${filtersQuery}`,
				{
					method: 'GET',
					signal
				}
			);

			return Result.ok(response);
		} catch (error) {
			return Result.error({
				message: 'Error while fetching clusters from the API.',
				source: 'nuxtClustersRepository.list',
				originalErrorObject: createOriginalErrorObject(error)
			});
		}
	}
};
